import { createNamedContext } from '@trinity/chat-components/utils';

type TableContextValue = {
  EmptyComponent?: React.ComponentType;
  empty: boolean;
  loading: boolean;
  pageSize: number;
};

export const TableContext = createNamedContext<TableContextValue | undefined>(undefined, 'Table.Context');
